import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Bellevue from '../../components/Bellevue/Bellevue'

const Bellevuepage = () => {
  return (
    <div>
        <Navbar/>
        <Bellevue/>



        <Footer/>
    </div>
  )
}

export default Bellevuepage